import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import classes from "./styles.module.scss";
import WebLogo from "../../../../assets/images/WebLogo.png";
import ButtonSecondary from "../../../../components/buttonSecondary";
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { onLogout } from "../../../../store/authAdmin/actions"; // ✅ FIX: use authAdmin store, not public auth store
import * as APIs from "../../apis"


const Header = (props) => {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const isActive = (path) => {
        const active = location.pathname.includes(path);
        return active;
    };

    const [showAdminProfile, setShowAdminProfile] = useState(false);


    const handleLogout = () => {
        dispatch(onLogout(navigate))
    }

    const handleRedirect = async () => {
        let res = await APIs.paymentAPi()
        if (res.status) {
            window.open("http://gyandeep.bihar.gov.in/Login.aspx?ID=" + res.data, '_blank')
        }
    }

    const schoolId = props?.admin?.auth?.user?.code;
    const numericId = schoolId?.replace(/\D/g, '');

    const renderStateNavigation = () => (
        <>
            <Link to="/admin/dashboardV2-admin">
                <li className={isActive('/dashboardV2-admin') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Dashboard</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/student-search">
                <li className={isActive('/student-search') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Search Student</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/school">
                <li className={isActive('/school') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Manage School</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/dashboard-admin">
                <li className={isActive('/dashboard-admin') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Old Dashboard (2024-25)</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/inquiry-list">
                <li className={isActive('/admin/inquiry-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Manage Inquiry</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
        </>
    );

    const renderDivisionNavigation = () => (
        <Link to="/admin/dashboardV2-admin">
            <li className={isActive('/dashboardV2-admin') ? classes.active : ""}>
                <div className={classes.bar_left}></div>
                <p>Dashboard</p>
                <div className={classes.bar_right}></div>
            </li>
        </Link>
    );

    const renderDistrictNavigation = () => (
        <>
            <Link to="/admin/dashboard">
                <li className={isActive('/dashboardV2-admin') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Dashboard</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/blockv2-list">
                <li className={isActive('/blockv2-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Block</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/randomization">
                <li className={isActive('/randomization') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Randomization</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/school-list-for-district">
                <li className={isActive('/school-list-for-district') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>School Intake Capacity</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/student-verification">
                <li className={isActive('/student-verification') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Student Verification</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/block-list">
                <li className={isActive('/block-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Old Block (2024-25)</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
        </>
    );

    const renderBlockNavigation = () => (
        <>
            <Link to="/admin/dashboard">
                <li className={isActive('/dashboard') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Dashboard</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/school-v2">
                <li className={isActive('/school-v2') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Student</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/schoolv2-list">
                <li className={isActive('/schoolv2-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>School</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/school-list">
                <li className={isActive('/school-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Old School (2024-25)</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
        </>
    );

    const renderSchoolNavigation = () => (
        <>
            <Link to="/admin/dashboard">
                <li className={isActive('/admin/dashboard') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Dashboard</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/school-student-list">
                <li className={isActive('/admin/school-student-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Student</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/school-entry">
                <li className={isActive('/school-entry') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>School intake capacity</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
            <Link to="/admin/student-list">
                <li className={isActive('/student-list') ? classes.active : ""}>
                    <div className={classes.bar_left}></div>
                    <p>Old school (2024-25)</p>
                    <div className={classes.bar_right}></div>
                </li>
            </Link>
        </>
    );

    const renderDefaultNavigation = () => (
        <Link to="/admin/dashboard">
            <li className={isActive('/dashboard') ? classes.active : ""}>
                <div className={classes.bar_left}></div>
                <p>Dashboard</p>
                <div className={classes.bar_right}></div>
            </li>
        </Link>
    );

    const renderNavigationByRole = () => {
        const role = props.admin?.auth?.user?.role;
        switch (role) {
            case "state":
                return renderStateNavigation();
            case "division":
                return renderDivisionNavigation();
            case "district":
                return renderDistrictNavigation();
            case "block":
                return renderBlockNavigation();
            case "school":
                return renderSchoolNavigation();
            default:
                return renderDefaultNavigation();
        }
    };
    return (
        <div className={classes.header_container}>
            <div className={classes.header_content}>
                <div className={classes.logo_menus}>
                    <img className={classes.web_logo} src={WebLogo} alt="WebLogo" />
                    <ul className={classes.nav_menus}>
                        {renderNavigationByRole()}
                    </ul>
                </div>

                <div className={classes.profile_logout}>
                    {parseInt(numericId) <= 6991 && (props?.admin?.auth?.user?.role === "school") &&
                        <ButtonSecondary
                            onClick={handleRedirect}
                            button_text="Login to Payment"
                            variant="variantOne"
                            second_className={classes.logout_button}
                        />}
                    <ButtonSecondary
                        onClick={handleLogout}
                        button_text="Logout"
                        variant="variantOne"
                        icon_two={<LogoutRoundedIcon />}
                        second_className={classes.logout_button}
                    />
                </div>
            </div>
        </div>
    );
}


Header.propTypes = {
    admin: PropTypes.shape({
        auth: PropTypes.shape({
            user: PropTypes.shape({
                role: PropTypes.string,
                code: PropTypes.string
            })
        })
    })
};

const mapStateToProps = (state) => ({
    admin: state.AuthAdmin
})
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(Header);

